import { gql, type TypedDocumentNode } from "@apollo/client";
import { JOB_APPLICANT_COUNT_ESTIMATE_FRAGMENT, JobApplicantCountEstimateMatchTier } from "./queries";

export type JobApplicantCountEstimateCompensationInput = {
  baseMinimum?: number;
  baseMaximum?: number;
  totalAnticipated?: number;
  currencyUnit?: string;
};

export type JobApplicantCountEstimateInput = {
  serviceLevel?: string;
  applicantGroup?: string;
  category?: string;
  categoryType?: string;
  state?: string;
  sectionName?: string;
  positionType?: string;
  paySchedule?: string;
  requiredEducation?: string;
  additionalPgaEducation?: string;
  requiredExperienceInYears?: number;
  applyVia?: string;
  compensation?: JobApplicantCountEstimateCompensationInput;
};

export type EstimateJobApplicantCountPayload = {
  low: number | null;
  high: number | null;
  median: number | null;
  sampleSize: number | null;
  matchTier: JobApplicantCountEstimateMatchTier | null;
  estimatorVersion: string;
  disclaimer: string;
  criteriaComplete: boolean;
  missingCriteria: string[];
};

export type EstimateJobApplicantCountMutationResponse = {
  estimateJobApplicantCount: EstimateJobApplicantCountPayload | null;
};

export type EstimateJobApplicantCountMutationVariables = {
  input: JobApplicantCountEstimateInput;
};

export const ESTIMATE_JOB_APPLICANT_COUNT_MUTATION: TypedDocumentNode<
  EstimateJobApplicantCountMutationResponse,
  EstimateJobApplicantCountMutationVariables
> = gql`
  mutation EstimateJobApplicantCount($input: JobApplicantCountEstimateInput!) {
    estimateJobApplicantCount(input: $input) {
      ...JobApplicantCountEstimateFields
    }
  }
  ${JOB_APPLICANT_COUNT_ESTIMATE_FRAGMENT}
`;
